export default function ConsumerHealthDataPolicy() {
  return (
    <main style={{ maxWidth: 720, margin: '0 auto', padding: '2rem' }}>
      <h1>Consumer Health Data Policy</h1>
      <p>This page is a placeholder. Add the full Consumer Health Data Policy content here later.</p>
    </main>
  );
}